import axios from "axios";

export default {

    postApi(url,param) {
      return  axios.post(url,param);
    },

     getApi(url) {
      return axios.get(url);
    },

    getApiParms(url, param) {
      return axios.get(url, param);
    },
    
    getApiConfig(url, param, config) {
      return axios.get(url, param, config);
    },

    putApi(url) {
        return axios.get(url);
    },

    deleteApi(url,param) {
        return axios.get(url,param);
    }
  };